import React, { Fragment } from "react";
import "./add-words.css";
import Modal from "../../components/modal/modal-component";
import SelectLabel from "../select-label/select-label-container";
import {Link} from "react-router-dom";



const AddWordsComponent = ({
  taxonomyList,
  taxonomyChange,
  selectedTaxonomy,
  loading,
  closeModal,
  words,
  wordChange,
  addInput,
  removeInput,
  modalIsShown,
  addWords,
  onCloseModal,
  validation,
   textAreaWordsChange,
   textAreaWords,
   textAreaWordsProcessed,
   toggleLabelSelection,
   selectedLabelColor,
   labelSelectionIsShown,
   selectLabelColor,
   wordsAreEmpty,
  commentChange,
  comment
}) => {
  return (
    <Modal
      show={modalIsShown}
      title="Add Words"
      save={addWords}
      async={true}
      loading={loading}
      close={onCloseModal}
    >
      <div className="add_words">
        <Fragment>
          <div className="add_words__select_container">
            <span>Select taxonomy</span>
            {taxonomyList.length ? (
              <select
                value={selectedTaxonomy}
                onChange={e => taxonomyChange(e.target.value)}
              >
                {taxonomyList.map((t, i) => (
                  <option key={i} value={t._id}>
                    {t._id}
                  </option>
                ))}
              </select>
            ) : (
              <span>Taxonomy list is empty...</span>
            )}
            <Link
              to="/add-taxonomy"
              style={{
                textDecoration: 'none'
              }}
              onClick={closeModal}
            >Add taxonomy</Link>
          </div>
          <div className="add_words__words_container">
            <span style={{ marginBottom: "10px" }}>New words:</span>
            <textarea
              onChange={e => textAreaWordsChange(e.target.value)}
              value={textAreaWords}
              className="add_words__textarea"
            />
            <span style={{
              color: 'red',
              display: wordsAreEmpty ? 'block' : 'none'
            }}>It should not be empty</span>
            <div style={{
              padding: '10px',
              display: textAreaWordsProcessed.length ? 'block' : 'none'
            }}>
              <span style={{fontWeight: '400'}}>These words you want to add:</span>
            {
              textAreaWordsProcessed.map((w, i) => (
                <div key={i}>
                  <span>{i + 1} </span>
                  <span>{w}</span>
                </div>
                )
              )
            }
            </div>
            <div style={{padding: '10px 0'}}>
              <SelectLabel />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingBottom: '15px'
            }}>
                <span style={{marginBottom: '10px'}}>Write comment for the words:</span>
                <textarea
                  style={{height: '150px'}}
                  id="comment-textarea"
                  maxLength="250"
                  className="add_words__textarea"
                  value={comment}
                  onChange={e => commentChange(e.target.value)}
                />
            </div>

          </div>
        </Fragment>
      </div>
    </Modal>
  );
};

export default AddWordsComponent;



// WEBPACK FOOTER //
// ./src/modules/add-words/add-words-component.js